import apiClient from './client';

export const ValidationHistoryAxiosInstance = apiClient;